import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import UsersManagementFormPicker from '../../components/users/form/UserManagementFormPicker'

import { ROUTE_USERS_MANAGEMENT } from '@@partner:config/routes'

export default function UsersManagementFormPage () {
  const { type = 'none', id = null } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_USERS_MANAGEMENT, {
    type
  })

  return (
    <div className="UsersManagementPage">
      <h1 className="u-heading">
        {id ? 'Редактирование' : 'Добавление'} сотрудника
      </h1>
      <Panel shaded>
        <UsersManagementFormPicker
          type={type}
          id={id}
          onSaved={redirectToCatalog}
        />
      </Panel>
    </div>
  )
}
